<template>
  <span class="d-flex">
    <span
      v-clipboard:copy="text"
      v-clipboard:success="copySuccess"
      class="position-relative cursor-pointer text-break text-main"
    >
      <span
        v-if="!showPassword"
        type="text"
        class="password-hidden text-main"
        :class="{ 'text-hidden': textHidden, white: whiteBackground }"
      >
        <slot>{{ text }}</slot>
      </span>
      {{ text }}
    </span>
    <span
      v-if="!hideCopyIcon"
      v-clipboard:copy="text"
      v-clipboard:success="copySuccess"
      class="text-secondary cursor-pointer"
    >
      <GjIcon
        name="Copy"
        size="20"
      />
    </span>
    <a
      style="margin-left: 5px;"
      @click="$emit('toggle')"
    >
      <GjIcon
        :key="`password${showPassword}`"
        :name="showPassword ? 'Hide' : 'Show'"
        size="20"
      />
    </a>
  </span>
</template>
<script>
export default {
  name: 'TextHidden',
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
    showPassword: {
      type: Boolean,
      required: true,
    },
    textHidden: {
      type: Boolean,
      default: true,
    },
    whiteBackground: {
      type: Boolean,
      default: false,
    },
    hideCopyIcon: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.password-hidden {
  background-color: #f7f7f9;
  position: absolute;
  width: 100%;
  height: 100%;
  &.text-hidden {
    -webkit-text-security: circle;
  }
  &.white {
    background-color: var(--white);
  }
}
</style>
